import { ReactFC } from 'common/types/ReactFC'
import React from 'react'
import LargeIconCard from './base/LargeIconCard'
import { mailroomStrings } from 'common/strings/mailroom-strings'

type EKYCCardType = {}

const EKYCCard: ReactFC<EKYCCardType> = ({}) => {
  return (
    <LargeIconCard
      className='d-flex justify-content-center plug-card search-post-card pt-lg-0 ps-lg-10 ps-6'
      padding='sm'
      icon='hoxton-mix-symbol'
      color='white'
      theme='gradient-red'
    >
      <h3
        className={'search-post-text text-bold color-white mt-lg-3'}
        dangerouslySetInnerHTML={{
          __html: `${mailroomStrings.searchPost}`,
        }}
      />
    </LargeIconCard>
  )
}

export default EKYCCard
